import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { persistor, store } from './store/store';

export type AppProviderProps = {
    children: React.ReactNode;
    store: typeof store;
    persistor: typeof persistor;
};

export const AppProviders = ({ children, store, persistor }: Readonly<AppProviderProps>) => {
    return (
        <Provider store={store as any}>
            <PersistGate loading={null} persistor={persistor}>
                {children}
            </PersistGate>
        </Provider>
    );
};
